import { createGroq } from "@ai-sdk/groq";
import { wrapLanguageModel, extractReasoningMiddleware } from "ai";
import { envVariables } from "@/lib/envVariables";

/**
 * Groq provider configuration
 */
export const groq = createGroq({
  apiKey: envVariables.GROQ_API_KEY,
});

/**
 * Model ID constants
 */
export const KIMI_K2_INSTRUCT_MODEL = "moonshotai/kimi-k2-instruct";
export const QWEN3_32B_MODEL = "qwen/qwen3-32b";
export const GEMMA2_9B_IT_MODEL = "gemma2-9b-it";

/**
 * Helper function to get Groq provider with Kimi K2 Instruct model
 */
export const kimiK2 = (model = KIMI_K2_INSTRUCT_MODEL) => groq(model);

/**
 * Helper function to get Groq provider with Qwen3 32B model with reasoning extraction
 */
export const qwen332B = (model = QWEN3_32B_MODEL) =>
  wrapLanguageModel({
    model: groq(model),
    middleware: extractReasoningMiddleware({ tagName: "think" }),
  });

/**
 * Helper function to get Groq provider with Gemma 2 9B IT model
 */
export const gemma29B = (model = GEMMA2_9B_IT_MODEL) => groq(model);
